// extracted by mini-css-extract-plugin
export default {"wrapper":"Gallery_wrapper__mzh8h","gallery":"Gallery_gallery__z1EI7","orderButton":"Gallery_orderButton__Un29j","text":"Gallery_text__43nED"};